/* LMT Creative — reusable personalized product page (sections/lmt-product.liquid).
   Reads the product's variants, shows friendly choices (subjects / format / size / frame / mat),
   keeps the hidden variant id in sync, and handles the personalization fields, uploads,
   preview, validation and submit. One instance per [data-lmt-product] root. */
(function () {
  'use strict';

  function init(root) {
    var D = JSON.parse(root.querySelector('[data-product-json]').textContent);
    var P = D.product, T = D.text || {};
    var $ = function (s) { return root.querySelector(s); };
    var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };

    // ---------- options -> normalized variants ----------
    var names = P.options.map(function (o) { return String(o.name || o); });
    function idx(re) { for (var i = 0; i < names.length; i++) if (re.test(names[i])) return i; return -1; }
    var I_SUBJ = idx(/\bpets?\b|\bpeople\b|\bpersons?\b|\bsubjects?\b/i);
    var I_SIZE = idx(/size/i);
    var I_FMT = idx(/format|digital or/i);
    var I_FRAME = -1;
    names.forEach(function (n, i) { if (i !== I_FMT && i !== I_SIZE && i !== I_SUBJ && /frame|print/i.test(n)) I_FRAME = i; });
    if (I_FMT === I_FRAME) I_FMT = -1;
    // Any other option (e.g. "Personalization") is shown as its own row of buttons.
    var OTHER = []; names.forEach(function (n, i) { if ([I_SUBJ, I_SIZE, I_FMT, I_FRAME].indexOf(i) < 0) OTHER.push(i); });

    function opt(v, i) { return i < 0 ? '' : ((v.options && v.options[i]) || ''); }
    function fmtKey(s) { return /digital/i.test(s) ? 'digital' : /canvas/i.test(s) ? 'canvas' : 'print'; }
    function parseFrame(s) {
      if (!s || /no frame|unframed|digital/i.test(s)) return { color: 'none', mat: false };
      return { color: s.replace(/\s*frame.*$/i, '').replace(/\s*(with|w\/|\+)\s*mat.*$/i, '').trim(), mat: /mat/i.test(s) };
    }
    function norm(v) {
      var frameVal = opt(v, I_FRAME), f = parseFrame(frameVal);
      var fmt = I_FMT >= 0 ? fmtKey(opt(v, I_FMT)) : fmtKey(frameVal);
      if (fmt === 'digital') f = { color: 'none', mat: false };
      return { subj: opt(v, I_SUBJ), size: opt(v, I_SIZE), fmt: fmt, color: f.color, mat: f.mat, ox: OTHER.map(function (i) { return opt(v, i); }) };
    }
    var N, SUBJS, SIZES, FMTS, COLORS, OVALS;
    function uniq(a) { var o = []; a.forEach(function (x) { if (x && o.indexOf(x) < 0) o.push(x); }); return o; }
    function setup() {
      N = {};
      P.variants.forEach(function (v) { N[v.id] = norm(v); });
      var all = P.variants.map(function (v) { return N[v.id]; });
      SUBJS = uniq(all.map(function (n) { return n.subj; }));
      SIZES = uniq(all.map(function (n) { return n.size; }));
      FMTS = ['digital', 'print', 'canvas'].filter(function (k) { return all.some(function (n) { return n.fmt === k; }); });
      OVALS = OTHER.map(function (i, k) { return uniq(all.map(function (n) { return n.ox[k]; })); });
      COLORS = ['none'];
      all.forEach(function (n) { if (COLORS.indexOf(n.color) < 0) COLORS.push(n.color); });
    }
    setup();
    var hasFrames = function () { return COLORS.length > 1; };

    var SWATCH = { black: '#1f1d1c', white: '#f3f1ee', grey: '#8a8580', gray: '#8a8580', honey: '#9a6337', blonde: '#d8c1a2', barnwood: '#8c8272', whitewash: '#e4ddd1' };
    var FMT = {
      digital: [T.digitalLabel || 'Digital file', T.digitalDesc || ''],
      print: [T.printLabel || 'Print', T.printDesc || ''],
      canvas: [T.canvasLabel || 'Canvas', T.canvasDesc || '']
    };
    var NEXT = { '5x7': '8x10', '8x10': '11x14', '11x14': '16x20', '16x20': '20x24' };

    function money(c) {
      var f = D.moneyFormat || '${{amount}}', n = c / 100;
      return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
        if (k === 'amount_no_decimals') return Math.round(n).toLocaleString('en-US');
        if (k === 'amount_with_comma_separator') return n.toFixed(2).replace('.', ',');
        return n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      });
    }
    function same(a, b) { return String(a).toLowerCase() === String(b).toLowerCase(); }
    function find(s) {
      var c = s.fmt === 'digital' ? 'none' : s.color, m = s.fmt === 'digital' ? false : s.mat;
      return P.variants.filter(function (v) {
        var n = N[v.id];
        return n.subj === s.subj && n.size === s.size && n.fmt === s.fmt && same(n.color, c) && n.mat === m && n.ox.join('|') === (s.ox || []).join('|');
      })[0] || null;
    }
    function ok(v) { return v && v.available; }
    function withS(o) { var x = { subj: S.subj, size: S.size, fmt: S.fmt, color: S.color, mat: S.mat, ox: S.ox.slice() }; for (var k in o) x[k] = o[k]; return x; }
    function minPrice(filter) { var m = null; P.variants.forEach(function (v) { if (ok(v) && filter(N[v.id]) && (m === null || v.price < m)) m = v.price; }); return m; }

    // ---------- state ----------
    var S = { subj: SUBJS[0] || '', size: SIZES[0] || '', ox: OVALS.map(function (x) { return x[0] || ''; }), swatchPhoto: null, fmt: FMTS.indexOf('print') >= 0 ? 'print' : FMTS[0], color: 'none', mat: false, lastColor: null, view: null };
    function load(v) { var n = N[v.id]; S.subj = n.subj; S.size = n.size; S.fmt = n.fmt; S.color = n.color; S.mat = n.mat; S.ox = n.ox.slice(); }
    (function initState() {
      var v = P.variants.filter(function (x) { return x.id === D.initialVariant; })[0];
      var d = D.defaults || {};
      if (!D.urlHasVariant) {
        var pick = null;
        if (d.cheapestPrint) {
          P.variants.forEach(function (x) { var n = N[x.id]; if (ok(x) && n.fmt === 'print' && n.color === 'none' && (!pick || x.price < pick.price)) pick = x; });
        } else {
          var f = parseFrame(d.frame && d.frame !== 'none' ? d.frame + ' Frame' : '');
          pick = find({ subj: d.subjects || SUBJS[0] || '', size: d.size || SIZES[0] || '', fmt: d.format || 'print', color: f.color, mat: f.mat, ox: S.ox });
        }
        if (ok(pick)) v = pick;
      }
      if (v) load(v);
      if (S.color !== 'none') S.lastColor = S.color;
    })();
    function cur() { return find(S); }

    function fixState() {
      var notes = [];
      if (S.fmt === 'digital') { S.color = 'none'; S.mat = false; }
      else if (S.color !== 'none' && !ok(cur())) {
        if (S.mat && ok(find(withS({ mat: false })))) { notes.push(S.color + ' with a mat isn’t available at ' + S.size + ', so we removed the mat.'); S.mat = false; }
        else { notes.push('The ' + S.color + ' frame isn’t available at ' + S.size + '.'); S.color = 'none'; S.mat = false; }
      }
      if (!ok(cur())) {
        var like = function (v) { var n = N[v.id]; return ok(v) && n.subj === S.subj && n.fmt === S.fmt; };
        var alt = P.variants.filter(function (v) { return like(v) && N[v.id].size === S.size; })[0] || P.variants.filter(like)[0];
        if (alt) load(alt);
      }
      return notes;
    }

    function btn(cls, html, pressed, disabled) {
      var b = document.createElement('button'); b.type = 'button'; b.className = cls; b.innerHTML = html;
      b.setAttribute('aria-pressed', pressed ? 'true' : 'false'); b.disabled = !!disabled; return b;
    }
    function sizeLabel(s) { return String(s).replace('"', '″'); }

    // ---------- conditional fields ----------
    // data-show-format="physical": hidden for digital files. data-show-if="Gift=Yes": shown only while the
    // field named Gift has an answer starting with "Yes". Hidden fields are disabled, so they're never sent.
    function shown(el) { var w = el.closest('.lmt-field'); return !(w && w.hidden); }
    function propValue(nm) { var el = root.querySelector('[name="properties[' + nm + ']"]'); if (!el) return ''; return el.type === 'checkbox' ? (el.checked ? el.value : '') : (el.value || ''); }
    // One condition: "Gift=Yes" (another field's answer starts with Yes) or "option:Personalization=Two Names (two"
    // (the chosen value of a product option starts with that text). Several conditions separated by | mean "any of".
    function test(c) {
      if (c.indexOf('=') < 0) return false;
      var nm = c.slice(0, c.indexOf('=')).trim(), val = c.slice(c.indexOf('=') + 1).trim().toLowerCase();
      if (/^option:/i.test(nm)) { var oi = names.indexOf(nm.slice(7).trim()), v = cur(); return oi >= 0 && !!v && opt(v, oi).toLowerCase().indexOf(val) === 0; }
      var ctl = root.querySelector('[name="properties[' + nm + ']"]');
      return !!ctl && shown(ctl) && propValue(nm).toLowerCase().indexOf(val) === 0;
    }
    function applyVisibility() {
      for (var pass = 0, changed = true; changed && pass < 4; pass++) {
        changed = false;
        $$('[data-show-format],[data-show-if]').forEach(function (w) {
          var show = !(w.getAttribute('data-show-format') === 'physical' && S.fmt === 'digital');
          var c = w.getAttribute('data-show-if');
          if (show && c && c.indexOf('=') > 0) show = c.split('|').some(test);
          if (w.hidden !== !show) { w.hidden = !show; changed = true; }
          Array.prototype.slice.call(w.querySelectorAll('input,textarea,select')).forEach(function (i) { i.disabled = !show; });
        });
      }
    }

    // ---------- render step 1 + price ----------
    function render(notes) {
      // subjects
      var sf = $('[data-subj-field]');
      sf.hidden = SUBJS.length < 2;
      if (!sf.hidden) {
        $('[data-subj-label]').textContent = T.subjectLabel || names[I_SUBJ];
        var sEl = $('[data-subjects]'); sEl.innerHTML = '';
        SUBJS.forEach(function (p) {
          var m = minPrice(function (n) { return n.subj === p; });
          var num = (p.match(/\d+/) || [p])[0], word = p.replace(/^\s*\d+\s*/, '');
          var b = btn('lmt-opt center', '<b>' + num + '</b><small>' + word.toLowerCase() + '</small>', S.subj === p, m === null);
          b.onclick = function () { S.subj = p; S.view = null; render(fixState()); };
          sEl.appendChild(b);
        });
      }
      // other options
      var oEl = $('[data-other-options]');
      if (oEl) {
        oEl.innerHTML = '';
        OTHER.forEach(function (oi, k) {
          if (OVALS[k].length < 2) return;
          var f = document.createElement('div'); f.className = 'lmt-field';
          f.innerHTML = '<div class="lmt-label">' + esc(names[oi]) + '</div><div class="lmt-opts fmt"></div>';
          OVALS[k].forEach(function (val) {
            var ox = S.ox.slice(); ox[k] = val;
            var v2 = find(withS({ ox: ox })), m = minPrice(function (n) { return n.ox[k] === val && n.subj === S.subj; });
            var b = btn('lmt-opt', '<b>' + esc(val) + '</b><small class="lmt-from">' + (ok(v2) ? money(v2.price) : m !== null ? 'from ' + money(m) : 'Unavailable') + '</small>', S.ox[k] === val, m === null);
            b.onclick = function () { S.ox[k] = val; render(fixState()); };
            f.lastChild.appendChild(b);
          });
          oEl.appendChild(f);
        });
      }
      var szf = $('[data-size-field]'); if (szf) szf.hidden = SIZES.length < 2;
      // formats
      $('[data-fmt-field]').hidden = FMTS.length < 2;
      var fEl = $('[data-formats]'); fEl.innerHTML = '';
      FMTS.forEach(function (f) {
        var m = minPrice(function (n) { return n.subj === S.subj && n.fmt === f; });
        var b = btn('lmt-opt', '<b>' + FMT[f][0] + '</b><small>' + FMT[f][1] + '</small><small class="lmt-from">' + (m !== null ? 'from ' + money(m) : 'Unavailable') + '</small>', S.fmt === f, m === null);
        b.onclick = function () { S.fmt = f; S.view = null; if (f !== 'digital' && S.color === 'none' && S.lastColor) S.color = S.lastColor; render(fixState()); };
        fEl.appendChild(b);
      });
      // sizes
      var dig = S.fmt === 'digital';
      var zEl = $('[data-sizes]'); zEl.innerHTML = '';
      SIZES.forEach(function (sz) {
        var v = dig ? find(withS({ size: sz })) : (find(withS({ size: sz })) || find(withS({ size: sz, color: 'none', mat: false })));
        var avail = ok(v) || (!dig && ok(find(withS({ size: sz, color: 'none', mat: false }))));
        var b = btn('lmt-opt center', '<b>' + sizeLabel(sz) + '</b><small class="lmt-from">' + (ok(v) ? money(v.price) : (avail ? '' : '—')) + '</small>', S.size === sz, !avail);
        b.onclick = function () {
          S.size = sz; S.view = null;
          if (!dig && S.color === 'none' && S.lastColor && ok(find(withS({ size: sz, color: S.lastColor, mat: false })))) S.color = S.lastColor;
          render(fixState());
        };
        zEl.appendChild(b);
      });
      $('[data-size-hint]').textContent = dig ? (T.digitalSizeHint || '') : '';
      // frames
      $('[data-frame-field]').hidden = dig || !hasFrames();
      var frEl = $('[data-frames]'); frEl.innerHTML = '';
      COLORS.forEach(function (c) {
        var any = c === 'none' || ok(find(withS({ color: c, mat: false }))) || ok(find(withS({ color: c, mat: true })));
        var label = c === 'none' ? 'No frame' : c;
        var b = btn('lmt-sw' + (c === 'none' ? ' none' : ''), '', same(S.color, c), !any);
        b.style.setProperty('--c', SWATCH[c.toLowerCase()] || '#ccc');
        var tex = D.swatches && D.swatches[c.toLowerCase()]; if (tex) b.style.backgroundImage = 'url("' + tex + '")';
        b.title = label + (any ? '' : ' — not available at this size'); b.setAttribute('aria-label', b.title);
        b.onclick = function () { S.color = c; S.view = null; S.lastColor = c === 'none' ? null : c; render(fixState()); };
        frEl.appendChild(b);
      });
      var v = cur(), base = find(withS({ color: 'none', mat: false }));
      $('[data-frame-name]').innerHTML = '<b>' + (S.color === 'none' ? 'No frame' : S.color) + '</b>' + (S.color !== 'none' && ok(v) && ok(base) ? ' · +' + money(v.price - base.price) : '');
      var anyMat = P.variants.some(function (x) { return N[x.id].mat; });
      var matOk = S.color !== 'none' && ok(find(withS({ mat: true })));
      $('[data-mat-toggle]').hidden = !anyMat;
      var mat = $('[data-mat]'); mat.checked = S.mat; mat.disabled = !matOk; $('[data-mat-toggle]').classList.toggle('is-off', !matOk);
      var nm = find(withS({ mat: false })), wm = find(withS({ mat: true }));
      $('[data-mat-hint]').textContent = S.color === 'none' ? 'Choose a frame to add a mat.' : (!matOk ? 'Not available with ' + S.color + ' at ' + S.size + '.' : 'Print stays ' + S.size + '; it arrives in a ' + (NEXT[String(S.size).replace(/"/g, '')] || 'larger') + '″ frame.' + (ok(nm) && ok(wm) ? ' ' + (wm.price >= nm.price ? '+' : '−') + money(Math.abs(wm.price - nm.price)) : ''));
      var n = $('[data-frame-note]'); n.hidden = !(notes && notes.length); if (notes && notes.length) n.textContent = notes.join(' ');

      // variant + price
      if (v) { $('[data-variant-input]').value = v.id; try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u); } catch (e) {} }
      var price = v ? v.price : 0, cmp = v && v.compare_at_price > v.price ? v.compare_at_price : null;
      $('[data-price-now]').textContent = v ? money(price) : 'Unavailable';
      var was = $('[data-price-was]'), pill = $('[data-price-pill]');
      was.hidden = !cmp; pill.hidden = !cmp;
      if (cmp) { was.textContent = money(cmp); pill.textContent = Math.round((cmp - price) / cmp * 100) + '% off'; }
      S.price = v ? price : null; S.cmp = cmp;
      totals();
      applyVisibility(); summary();
      renderImage(v); validate();
    }

    // ---------- paid add-ons (separate products, added to the cart on submit) ----------
    var ADDONS = $$('[data-addon]');
    function addonQty(a) { return +a.querySelector('[data-addon-qty]').textContent || 0; }
    function addonSum() { return ADDONS.reduce(function (s, a) { return s + (!a.hidden ? addonQty(a) * +a.getAttribute('data-price') : 0); }, 0); }
    function totals() {
      var has = S.price != null, extra = addonSum();
      $('[data-total]').textContent = has ? money(S.price + extra) : '—';
      $('[data-total-label]').textContent = S.cmp ? 'Total (you save ' + money(S.cmp - S.price) + ')' : 'Total';
      $('[data-bar-price]').textContent = has ? money(S.price + extra) : '—';
      $('[data-bar-sub]').innerHTML = S.cmp ? '<s>' + money(S.cmp + extra) + '</s>' : '';
    }
    ADDONS.forEach(function (a) {
      var q = a.querySelector('[data-addon-qty]'), max = +a.getAttribute('data-max') || 10;
      function set(n) { q.textContent = Math.max(0, Math.min(max, n)); a.classList.toggle('is-on', addonQty(a) > 0); totals(); summary(); }
      a.querySelector('[data-addon-minus]').onclick = function () { set(addonQty(a) - 1); };
      a.querySelector('[data-addon-plus]').onclick = function () { set(addonQty(a) + 1); };
    });
    function addonItems() {
      return ADDONS.filter(function (a) { return !a.hidden && addonQty(a) > 0; }).map(function (a) {
        return { id: +a.getAttribute('data-variant'), quantity: addonQty(a), properties: { 'For': a.getAttribute('data-for') } };
      });
    }

    function summary() {
      var pick = [SUBJS.length > 1 ? S.subj : '', S.size ? sizeLabel(S.size) + (FMTS.length > 1 || hasFrames() ? ' ' + FMT[S.fmt][0].toLowerCase() : '') : (FMTS.length > 1 ? FMT[S.fmt][0] : '')].concat(S.ox).filter(Boolean).join(', ');
      var rows = pick ? [['Your pick', pick]] : [];
      if (S.fmt !== 'digital' && hasFrames()) rows.push(['Frame', S.color === 'none' ? 'None' : S.color + (S.mat ? ' + mat' : '')]);
      $$('[data-summary-label]').forEach(function (el) {
        var pressed = el.hasAttribute('data-choice') ? el.querySelector('.lmt-opt[aria-pressed="true"] b') : null;
        if (!shown(el)) return;
        var val = el.type === 'checkbox' ? (el.checked ? el.value : '') : el.hasAttribute('data-choice') ? (pressed ? pressed.textContent : '') : (el.value || '');
        if (val) rows.push([el.getAttribute('data-summary-label'), val]);
      });
      ADDONS.forEach(function (a) { if (!a.hidden && addonQty(a) > 0) rows.push([a.getAttribute('data-label'), '× ' + addonQty(a)]); });
      if (T.summaryExtra && T.summaryExtra.indexOf(':') > 0) rows.push([T.summaryExtra.split(':')[0], T.summaryExtra.split(':').slice(1).join(':').trim()]);
      $('[data-summary]').innerHTML = rows.map(function (r) { return '<div><dt>' + esc(r[0]) + '</dt><dd>' + esc(r[1]) + '</dd></div>'; }).join('');
    }
    function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

    // ---------- images ----------
    // Hero follows the choice by media file name: tokens like "black", "black-mat", "digital",
    // "canvas"/"print"/"poster" (unframed). Shopify's "_<uuid>" suffix is ignored.
    function tokens(m) { return m.name.toLowerCase().replace(/\.[a-z]+$/, '').replace(/_[0-9a-f-]{16,}$/, '').split(/[-_\s]+/); }
    function mediaFor() {
      var list = D.media, has = function (t, w) { return t.indexOf(w) >= 0; };
      if (S.fmt === 'digital') return list.filter(function (m) { return has(tokens(m), 'digital'); })[0];
      if (S.color === 'none') return list.filter(function (m) { var t = tokens(m); return has(t, 'canvas') || has(t, 'print') || has(t, 'unframed') || has(t, 'poster'); })[0]
        || list.filter(function (m) { return has(tokens(m), 'digital'); })[0];
      var c = S.color.toLowerCase();
      return list.filter(function (m) { var t = tokens(m); return has(t, c) && (S.mat === has(t, 'mat')); })[0]
        || list.filter(function (m) { return has(tokens(m), c); })[0];
    }
    function imageFor(v) {
      if (S.swatchPhoto) return { src: S.swatchPhoto, id: null };
      var m = mediaFor(); if (m) return { src: m.src, id: m.id };
      if (v && D.variantImages[v.id]) return { src: D.variantImages[v.id], id: null };
      return D.media[0] ? { src: D.media[0].src, id: D.media[0].id } : null;
    }
    function tagText() {
      if (FMTS.length < 2 && !hasFrames()) return '';
      if (S.fmt === 'digital') return FMT.digital[0];
      if (S.color === 'none') return FMT[S.fmt][0] + ', no frame';
      return S.color + ' frame' + (S.mat ? ' + mat' : '');
    }
    function renderImage(v) {
      var img = S.view ? D.media.filter(function (m) { return m.id === S.view; })[0] : imageFor(v);
      var h = $('[data-hero]');
      if (img && h.getAttribute('src') !== img.src) { h.style.opacity = .3; h.onload = function () { h.style.opacity = 1; }; h.src = img.src; }
      var mi = $('[data-mini-img]');
      if (mi && img && !S.view && mi.getAttribute('data-src') !== img.src) { mi.style.opacity = .4; mi.onload = function () { mi.style.opacity = 1; }; mi.setAttribute('data-src', img.src); mi.src = img.src.replace(/width=\d+/, 'width=300'); }
      var mt = $('[data-mini-tag]'); if (mt) mt.textContent = tagText();
      var mp = $('[data-mini-price]'); if (mp) mp.textContent = v ? money(v.price) : '';
      var mn = $('[data-mini-note]'); if (mn) mn.textContent = 'Your current pick';
      $('[data-hero-tag]').textContent = S.view ? '' : tagText(); $('[data-hero-tag]').hidden = !!S.view || !tagText();
      var t = $('[data-thumbs]'); t.innerHTML = '';
      D.media.forEach(function (m) {
        var b = document.createElement('button'); b.type = 'button'; b.innerHTML = '<img alt="" loading="lazy" src="' + m.thumb + '">';
        b.setAttribute('aria-label', 'View photo'); b.setAttribute('aria-current', img && img.id === m.id ? 'true' : 'false');
        b.onclick = function () { S.view = m.id; S.swatchPhoto = null; renderImage(cur()); }; t.appendChild(b);
      });
    }

    // ---------- fonts, swatches, choices, preview ----------
    var fontBtns = $$('[data-font]');
    var font = null, PV = { bg: null, text: null };
    function placeholder() { return T.previewPlaceholder || ''; }
    function titleVal() { var el = $('[data-preview-role="title"]'); return el && el.value.trim() ? el.value.trim() : placeholder(); }
    function fitSamples() { $$('[data-font-sample]').forEach(function (s) { var size = 34; s.style.fontSize = size + 'px'; while (size > 11 && s.scrollWidth > s.clientWidth + 1) { size -= 1; s.style.fontSize = size + 'px'; } }); }
    function samples() { var t = titleVal(); $$('[data-font-sample]').forEach(function (s) { s.textContent = t; }); fitSamples(); }
    function preview() {
      var pt = $('[data-pv-title]'); if (!pt) return;
      pt.textContent = titleVal();
      var b = fontBtns.filter(function (x) { return x.getAttribute('data-font') === font; })[0];
      pt.style.fontFamily = b && b.getAttribute('data-family') ? "'" + b.getAttribute('data-family') + "',cursive" : '';
      var sub = $('[data-preview-role="subtitle"]'), ps = $('[data-pv-sub]');
      if (ps) ps.textContent = sub ? sub.value.trim() : '';
      var pv = $('[data-preview]'), sw = PV.bg;
      pt.style.color = PV.text ? (getComputedStyle(PV.text).getPropertyValue('--c') || '') : '';
      if (pv) { pv.classList.toggle('has-bg', !!sw); pv.style.backgroundColor = sw ? getComputedStyle(sw).getPropertyValue('--c') : ''; pv.style.backgroundImage = sw && sw.getAttribute('data-swatch-img') ? 'url("' + sw.getAttribute('data-swatch-img') + '")' : ''; }
    }
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitSamples);
    var fitT; window.addEventListener('resize', function () { clearTimeout(fitT); fitT = setTimeout(fitSamples, 150); });
    fontBtns.forEach(function (b, i) {
      b.onclick = function () { font = b.getAttribute('data-font'); var inp = $('[data-font-input]'); if (inp) inp.value = font; fontBtns.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); }); preview(); };
      if (i === 0) b.onclick();
    });
    // Color groups (each group = consecutive swatch blocks). data-preview="background"|"text" tints the preview;
    // a swatch with a photo shows it in the gallery when picked.
    function pickSwatch(g, b, quiet) {
      var btns = Array.prototype.slice.call(g.querySelectorAll('[data-swatch]')), val = b.getAttribute('data-swatch');
      g.querySelector('[data-swatch-input]').value = val;
      var nm = g.querySelector('[data-swatch-name]'); if (nm) nm.innerHTML = '<b>' + esc(val) + '</b>';
      btns.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      var role = g.getAttribute('data-preview'); if (role === 'background') PV.bg = b; if (role === 'text') PV.text = b;
      var ph = b.getAttribute('data-swatch-photo'); if (ph) { S.view = null; S.swatchPhoto = ph; }
      preview();
      if (!quiet) { summary(); validate(); if (ph) renderImage(cur()); }
    }
    $$('[data-swatch-group]').forEach(function (g) {
      var btns = Array.prototype.slice.call(g.querySelectorAll('[data-swatch]'));
      btns.forEach(function (b) { b.onclick = function () { pickSwatch(g, b); }; });
      if (g.hasAttribute('data-preselect') && btns[0]) pickSwatch(g, btns[0], true);
    });
    // Other sections (e.g. the color showcase) can pick a color: dispatch lmt:pick-swatch {property, value}.
    document.addEventListener('lmt:pick-swatch', function (e) {
      var d = e.detail || {};
      $$('[data-swatch-group]').forEach(function (g) {
        var inp = g.querySelector('[data-swatch-input]'); if (!inp || inp.name !== 'properties[' + d.property + ']') return;
        var b = Array.prototype.slice.call(g.querySelectorAll('[data-swatch]')).filter(function (x) { return same(x.getAttribute('data-swatch'), d.value); })[0];
        if (b) { pickSwatch(g, b); g.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
      });
    });
    $$('[data-choice]').forEach(function (g) {
      var inp = g.querySelector('[data-choice-input]');
      Array.prototype.slice.call(g.querySelectorAll('.lmt-opt')).forEach(function (b) {
        b.onclick = function () {
          inp.value = b.getAttribute('data-value');
          Array.prototype.slice.call(g.querySelectorAll('.lmt-opt')).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          applyVisibility(); summary(); validate();
        };
      });
    });

    // ---------- uploads ----------
    $$('[data-upload]').forEach(function (g) {
      var inputs = Array.prototype.slice.call(g.querySelectorAll('[data-file]'));
      var box = g.querySelector('[data-files]'), drop = g.querySelector('[data-drop]');
      function draw() {
        box.innerHTML = '';
        inputs.forEach(function (inp) {
          var f = inp.files && inp.files[0]; if (!f) return;
          var fig = document.createElement('figure'), img = document.createElement('img'), x = document.createElement('button');
          img.alt = 'Your photo'; img.src = URL.createObjectURL(f);
          x.type = 'button'; x.textContent = '×'; x.setAttribute('aria-label', 'Remove photo');
          x.onclick = function () { inp.value = ''; draw(); validate(); };
          fig.appendChild(img); fig.appendChild(x); box.appendChild(fig);
        });
      }
      function nextEmpty() { return inputs.filter(function (i) { return !(i.files && i.files.length); })[0]; }
      function add(list) {
        Array.prototype.slice.call(list).filter(function (f) { return /^image\//.test(f.type); }).forEach(function (f) {
          var inp = nextEmpty(); if (!inp) return; try { var dt = new DataTransfer(); dt.items.add(f); inp.files = dt.files; } catch (e) {}
        });
        draw(); validate();
      }
      inputs.forEach(function (inp) { inp.addEventListener('change', function () { draw(); validate(); }); });
      function pick(e) { e.preventDefault(); var inp = nextEmpty(); if (!inp) { toast('You can add up to ' + inputs.length + ' photo' + (inputs.length > 1 ? 's' : '')); return; } inp.click(); }
      drop.addEventListener('click', pick);
      drop.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') pick(e); });
      ['dragenter', 'dragover'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('is-over'); }); });
      ['dragleave', 'drop'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('is-over'); }); });
      drop.addEventListener('drop', function (e) { add(e.dataTransfer.files); });
    });

    // ---------- validation + submit ----------
    function missing() {
      var m = [];
      if (!ok(cur())) m.push(['an available option', 1]);
      var altFilled = $$('[data-upload-alt]').some(function (el) { return el.value.trim(); });
      $$('[data-upload][data-required]').forEach(function (g) {
        if (!shown(g)) return;
        var has = Array.prototype.slice.call(g.querySelectorAll('[data-file]')).some(function (i) { return i.files && i.files.length; });
        if (!has && !altFilled) m.push([g.getAttribute('data-label').toLowerCase(), +g.getAttribute('data-step-no')]);
      });
      $$('[data-field][data-required]').forEach(function (el) {
        if (!shown(el)) return;
        var v = el.value.trim(), bad = !v || (el.hasAttribute('data-email') && !/^\S+@\S+\.\S+$/.test(v));
        if (bad) m.push([el.getAttribute('data-label').toLowerCase(), +el.getAttribute('data-step-no')]);
      });
      $$('[data-choice][data-required]').forEach(function (g) {
        if (!shown(g)) return;
        if (!g.querySelector('[data-choice-input]').value) m.push([g.hasAttribute('data-summary-label') ? g.getAttribute('data-summary-label').toLowerCase() + ' choice' : g.getAttribute('data-label').replace(/\?$/, '').toLowerCase(), +g.getAttribute('data-step-no')]);
      });
      $$('[data-swatch-group][data-required]').forEach(function (g) {
        if (!shown(g)) return;
        if (!g.querySelector('[data-swatch-input]').value) m.push([g.getAttribute('data-label').toLowerCase(), +g.getAttribute('data-step-no')]);
      });
      $$('[data-check][data-required]').forEach(function (el) { if (shown(el) && !el.checked) m.push([el.getAttribute('data-label').toLowerCase(), +el.getAttribute('data-step-no')]); });
      return m.map(function (x, i) { return [x, i]; }).sort(function (a, b) { return a[0][1] - b[0][1] || a[1] - b[1]; }).map(function (x) { return x[0]; });
    }
    function validate() {
      var m = missing();
      $('[data-add]').setAttribute('aria-disabled', m.length ? 'true' : 'false');
      $('[data-todo]').innerHTML = m.length ? 'Still needed: <b>' + m.map(function (x) { return esc(x[0]); }).join(', ') + '</b>' : esc(T.readyText || '');
      $$('[data-step]').forEach(function (st) {
        var n = +st.getAttribute('data-step'); if (st.hasAttribute('data-variant-step')) return;
        st.classList.toggle('is-done', !m.some(function (x) { return x[1] === n; }));
      });
    }
    var toastT;
    function toast(msg) { var t = $('[data-toast]'); t.textContent = msg; t.classList.add('is-show'); clearTimeout(toastT); toastT = setTimeout(function () { t.classList.remove('is-show'); }, 2800); }
    var form = $('[data-form]');
    // Globo Product Options injects its own fields into product forms; remove them so only ours are sent.
    function stripInjected() {
      Array.prototype.slice.call(form.querySelectorAll('.gpo-container,.gpo-hidden-inputs,.gpo-clone-atc-button,[class*="gpo-app"]')).forEach(function (el) { el.remove(); });
      var orig = form.querySelector('[data-add]');
      if (orig) { orig.classList.remove('gpo-original-atc-button'); orig.hidden = false; orig.style.removeProperty('display'); }
    }
    stripInjected();
    if ('MutationObserver' in window) new MutationObserver(stripInjected).observe(form, { childList: true, subtree: true });
    form.addEventListener('submit', function (e) {
      var m = missing();
      if (m.length) {
        e.preventDefault();
        var st = $('[data-step="' + m[0][1] + '"]'); if (st) st.scrollIntoView({ behavior: 'smooth', block: 'center' });
        toast('Almost there — add your ' + m[0][0]); return;
      }
      // don't send empty fields to the order
      $$('[name^="properties["]').forEach(function (el) {
        var empty = el.type === 'file' ? !(el.files && el.files.length) : el.type === 'checkbox' ? !el.checked : !String(el.value || '').trim();
        if (empty) el.disabled = true;
      });
      $('[data-add]').classList.add('is-busy'); $('[data-add]').textContent = 'Adding…';
      // add-ons first (JSON, no files), then the real form post so photo uploads still work
      var items = addonItems();
      if (items.length) {
        e.preventDefault();
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
          .then(function (r) { if (!r.ok) throw new Error('add-on'); HTMLFormElement.prototype.submit.call(form); })
          .catch(function () {
            $$('[name^="properties["]').forEach(function (el) { el.disabled = false; }); applyVisibility();
            var b = $('[data-add]'); b.classList.remove('is-busy'); b.textContent = 'Add to cart';
            toast('Sorry, we couldn\'t add the extras. Please try again.');
          });
      }
    });
    window.addEventListener('pageshow', function () {
      $$('[name^="properties["]').forEach(function (el) { el.disabled = false; });
      applyVisibility();
      var b = $('[data-add]'); b.classList.remove('is-busy'); b.textContent = 'Add to cart';
    });
    $('[data-bar-add]').onclick = function () { if (form.requestSubmit) form.requestSubmit(); else form.submit(); };

    // ---------- other controls ----------
    $('[data-mat]').addEventListener('change', function (e) { S.mat = e.target.checked; S.view = null; render(fixState()); });
    $$('[data-preview-role]').forEach(function (el) { el.addEventListener('input', function () { samples(); preview(); }); });
    $$('[data-field]').forEach(function (el) { el.addEventListener('input', validate); });
    $$('[data-check]').forEach(function (el) { el.addEventListener('change', function () { applyVisibility(); summary(); validate(); }); });
    $$('[data-faq-link]').forEach(function (b) { b.onclick = function () { var d = root.querySelector('[id^="lmt-faq-' + b.getAttribute('data-faq-link') + '"]'); if (d) { d.open = true; d.scrollIntoView({ behavior: 'smooth', block: 'center' }); } }; });
    var cy = $('[data-create]'); if (cy) cy.onclick = function () { $('.lmt-step').scrollIntoView({ behavior: 'smooth', block: 'start' }); };
    var ba = $('[data-ba]'); if (ba) $('[data-ba-range]').addEventListener('input', function (e) { ba.style.setProperty('--pos', e.target.value + '%'); });
    if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { $('[data-bar]').classList.toggle('is-hidden', en[0].isIntersecting); }).observe($('[data-buy]'));

    samples(); preview(); render(fixState());

    // ---------- variants past the first 250 ----------
    // Liquid hands the page at most 250 variants; load the rest from the public Storefront API.
    if (D.variantsCount > P.variants.length || P.variants.length >= 250) {
      var have = {}; P.variants.forEach(function (v) { have[v.id] = 1; });
      var q = 'query($h:String!,$a:String){product(handle:$h){variants(first:250,after:$a){pageInfo{hasNextPage endCursor}nodes{id availableForSale price{amount}compareAtPrice{amount}image{url}selectedOptions{name value}}}}}';
      var more = function (after) {
        return fetch('/api/2025-07/graphql.json', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ query: q, variables: { h: P.handle, a: after } }) })
          .then(function (r) { return r.json(); }).then(function (j) {
            var c = j && j.data && j.data.product && j.data.product.variants; if (!c) return;
            c.nodes.forEach(function (n) {
              var id = +n.id.split('/').pop(); if (have[id]) return; have[id] = 1;
              var o = names.map(function (nm) { var s = n.selectedOptions.filter(function (x) { return x.name === nm; })[0]; return s ? s.value : ''; });
              P.variants.push({ id: id, options: o, available: n.availableForSale, price: Math.round(+n.price.amount * 100), compare_at_price: n.compareAtPrice ? Math.round(+n.compareAtPrice.amount * 100) : null });
              if (n.image) D.variantImages[id] = n.image.url + (n.image.url.indexOf('?') < 0 ? '?' : '&') + 'width=1200';
            });
            if (c.pageInfo.hasNextPage) return more(c.pageInfo.endCursor);
          });
      };
      more(null).then(function () { setup(); render(fixState()); }).catch(function () {});
    }
  }

  function boot() { Array.prototype.slice.call(document.querySelectorAll('[data-lmt-product]')).forEach(function (r) { if (!r.__lmt) { r.__lmt = 1; init(r); } }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
